module.exports = __webpack_public_path__ + "img/Accessibility-settings_En.a1d83c09.png";